<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>
      {{ (docType === 'trattamento' ? 'trattametoDati' : 'finalitaTrattamento') | tr }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="chiudi">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

@if (docType === 'trattamento') {
  <ion-content class="ion-padding">
    <div class="ion-text-center">
      <h2>INFORMATIVA AL TRATTAMENTO DEI DATI PERSONALI</h2>
      <p class="text__left">
        Ai sensi e per gli effetti dell'Art. 13 del Nuovo Regolamento Europeo 2016/679 relativo alla
        protezione delle persone fisiche con riguardo al trattamento dei dati personali (GENERAL
        DATA PROTECTION REGULATION – GDPR)
        Come richiesto dal Regolamento Generale sulla Protezione dei Dati Personali dell'Unione
        Europea (GDPR 2016/679, Articolo 13), prima di procedere al trattamento, l'Interessato
        (utente del sito internet www.sunset-palmi.it) è informato che i dati personali raccolti
        attraverso il sito sono oggetto di trattamento da parte della Società mediante strumenti
        informatici e/o telematici, per le finalità indicate nella presente informativa.
        A tal fine all'interessato è sottoposta l'Informativa Privacy predisposta da BEACH CLUB
        S.R.L. (di seguito anche "BEACHCLUB" o "la Società" o "il Titolare del Trattamento"),
        ideatore e promotore delle attività disponibili nel sito www.sunset-palmi.it.
        Titolare del trattamento
        Il Titolare del trattamento dei dati personali è BEACH CLUB S.R.L., con sede legale in Via
        Cellini, 16 - 89022, Cittanova, Reggio Calabria, Partita IVA: 02858550805.
        La Società ha identificato un Responsabile della Protezione dei Dati ai sensi degli articoli 37
        e seguenti del Regolamento Europeo 2016/679, che si individua nell' Dott. Francesco Macri.
        Tale soggetto potrà essere contattato per chiarimenti e questioni inerenti il trattamento dei
        dati personali all'indirizzo: beachclubsrl&#64;gmail.com.
        Per ulteriori informazioni relative ai diritti dell'interessato, si prega di considerare il
        Paragrafo denominato "Diritti degli interessati" della presente informativa.
        Informazioni sul trattamento
        I dati personali oggetto di trattamento vengono raccolti direttamente da parte di BEACH
        CLUB S.R.L. o da soggetti terzi da questa espressamente autorizzati, ovvero comunicati dalla
        Società a tali soggetti terzi per il perseguimento delle finalità di seguito descritte.
        Base giuridica e finalità del trattamento
        I dati personali conferiti dall'utente in occasione della navigazione sul sito internet
        www.sunset-palmi.it sono trattati dal Titolare conformemente alle vigenti normative in
        materia di Protezione dei dati personali.
        La base giuridica del trattamento si individua nella prestazione dei propri servizi da parte
        della Società, nella gestione e facilitazione del sito internet, nonché nella costituzione,
        esecuzione ed eventuale risoluzione del contratto di vendita on-line concluso tra le parti e
        negli obblighi al medesimo contratto connessi e/o dallo stesso direttamente e/o indirettamente
        derivanti.
        Il trattamento dei dati personali da parte di BEACHCLUB è volto al perseguimento delle
        seguenti finalità:
        1) REGISTRAZIONE A SUNSET BEACH PALMI: nel caso in cui l'utente decida di
        effettuare la registrazione all'applicazione Sunset Beach Palmi, solo in seguito ad un
        eventuale e specifico consenso, i dati personali saranno trattati dal Titolare del Trattamento ai
        fini della registrazione su Applicazione Sunset Beach Palmi. In particolare, a fronte del
        conferimento del proprio nome, cognome, indirizzo e-mail e dell'impostazione di una
        password di accesso, questi saranno trattati per la creazione di un account personale, per
        consentire la procedura di acquisto, per permettere all'utente di visualizzare lo stato degli
        ordini e ricevere aggiornamenti sugli acquisti effettuati, modificare le impostazioni personali
        ed aggiornare l'account, e visualizzare lo storico degli ordini.
        2) ATTIVITÀ DI SHOPPING ONLINE: i dati personali forniti saranno utilizzati ai fini
        dell'instaurazione, gestione, esecuzione e/o conclusione del contratto di vendita on-line. I dati
        conferiti saranno trattati dal Titolare del trattamento ai fini della gestione dell'ordine di
        acquisto con riferimento, a titolo esemplificativo, all'attività di pagamento, spedizione, presa
        in carico di eventuali resi, per assistenza clienti, per l'esecuzione delle finalità amministrativo
        – contabili legate alla gestione dell'ordine, per l'adempimento di obblighi previsti dalla
        normativa vigente. In caso di pagamento con carta di credito, le informazioni fondamentali
        per l'esecuzione della transazione (numero della carta di credito/debito, data di scadenza,
        codice di sicurezza) saranno trattate Paypal, Stripe o, eventualmente, da società incaricate del
        controllo antifrode tramite protocollo crittografato e senza che soggetti terzi possano in alcun
        modo avervi accesso. Tali informazioni non saranno comunque mai visualizzate né
        memorizzate da parte del venditore (BEACH CLUB S.R.L.).
        3) PROFILAZIONE DELLA PERSONA FISICA: i dati personali non sono trattati dal Titolare del Trattamento
        per attività di profilazione, ovvero di analisi delle preferenze volte alla creazione di contenuti
        e offerte personalizzate.
        4) NEWSLETTER E COMUNICAZIONI PROMOZIONALI: solo previo consenso facoltativo e separato dalla
        registrazione, BEACH CLUB S.R.L. può utilizzare indirizzo email, nome, data e ora del consenso e lingua
        di preferenza per inviare comunicazioni promozionali, offerte speciali, novità e aggiornamenti relativi al
        lido, al ristorante, al bar spiaggia, agli eventi, alle funzionalità dell'app e a iniziative territoriali,
        collaborazioni, contenuti e opportunità promozionali pubblicati su canali, siti o portali collegati a BEACH
        CLUB S.R.L. oppure ai quali Sunset Beach Club aderisce come attività presente o in evidenza, inclusi portali
        territoriali come "Ci vediamo in Calabria". Tali comunicazioni sono inviate da BEACH CLUB S.R.L. e non
        comportano il trasferimento della mailing list al portale o ai partner menzionati. L'utente può revocare il
        consenso in qualsiasi momento dall'area Profilo dell'app, tramite il link di disiscrizione presente nelle
        email o scrivendo a beachclubsrl&#64;gmail.com. I dati personali utilizzati per finalità promozionali non sono
        ceduti, venduti né comunicati a terzi per loro autonome attività di marketing, salvo separato e specifico
        consenso richiesto e ottenuto.
        5) ELIMINAZIONE DATI PERSONALI E CANCELLAZIONE ACCOUNT UTENTE: Per richiedere l'eliminazione del proprio account personale basta utilizzare l'apposita funzione nell'area personale dell'app.
        Oppure in alternativa è possibile richiedere la cancellazione contattandoci all'indirizzo email: beachclubsrl&#64;gmail.com
      </p>
    </div>
  </ion-content>
}

@if (docType === 'finalita') {
  <ion-content class="iframe-content">
    <iframe src="https://www.sunset-palmi.it/privacy_policies.html" frameborder="0"></iframe>
  </ion-content>
}
